export default {
	"forexceptcreate": {
		"keywords": "t关键词"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/forexcept/forexcept.js